import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent implements OnInit {
  loading = false;
  result: any;

  changePasswordForm: FormGroup = this.fb.group({
    currentPassword: ['', Validators.required],
    password: ['', Validators.required],
    passwordVerify: ['', Validators.required],
  });


  get passwordsEqual() {
    if (this.changePasswordForm.get('password').value === this.changePasswordForm.get('passwordVerify').value) {
      return true;
    } else {
      return false;
    }
  }

  constructor(private auth: AuthService, private route: ActivatedRoute, private fb: FormBuilder) { }

  ngOnInit() { }

  async changePassword(val: any) {
    this.loading = true;
    this.result = await this.auth
      .changePassword(val)
      .toPromise();
    this.loading = false;
  }
}
